import React from 'react'
import { Link } from 'react-router-dom'

const Homepage: React.FC = () => {
	return (
		<div className="homepage full-screen">
			<div className="bg-blue">
				<Link
					to="/stories"
					className="w-full h-full flex-center remove-decoration remove-tap-highlight">
					<span>
						If you are interested in reading our most fun stories,
						choose this side.
					</span>
				</Link>
			</div>
			<div className="bg-salmon">
				<Link
					to="/playground"
					className="w-full h-full flex-center remove-decoration remove-tap-highlight">
					<span>
						If you are interested in spending some playfull time,
						choose this side.
					</span>
				</Link>
			</div>
		</div>
	)
}

export default Homepage
